import React from 'react';
import PropTypes from 'prop-types';
import { DropdownSelect } from '../dropdown-select/DropdownSelect';
import { genderIdentity } from '../../config/constants/genderIdentityConstant';

const SelectGenderIdentity = ({ value, onChange }) => {
  const options = Object.values(genderIdentity);
  return <DropdownSelect options={options} value={value} onChange={onChange} />;
};

export default SelectGenderIdentity;

SelectGenderIdentity.propTypes = {
  value: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  onChange: PropTypes.func,
};
